import Vue from 'vue';
import { API_HOST } from '../constants';

export default {
  get(params = {}) {
    return Vue.axios.get(`${API_HOST}/transport-service`, { params });
  },
  getCategories() {
    return Vue.axios.get(`${API_HOST}/transport-service-categories`);
  },
};



// WEBPACK FOOTER //
// ./src/api/service.js